
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthSelectors } from '@shared/store/auth/auth.selectors';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

export const isNotAdminAndSuperUserGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);
  const router = inject(Router);

  return combineLatest([
    store.select(AuthSelectors.isAdmin),
    store.select(AuthSelectors.isSuperUser)
  ]).pipe(
    map(([ isAdmin, superUser ]) => {
      return (!isAdmin && !superUser) || router.parseUrl('/patients');
    })
  );
};
